export const ATTENDANCE_NETWORK_PERMISSION_CODES = {
    WEB_ATTENDANCE_NETWORK_LIST: 'WEB_ATTENDANCE_NETWORK_LIST',
    WEB_ATTENDANCE_NETWORK_DETAIL: 'WEB_ATTENDANCE_NETWORK_DETAIL',
    WEB_ATTENDANCE_NETWORK_ADD: 'WEB_ATTENDANCE_NETWORK_ADD',
    WEB_ATTENDANCE_NETWORK_EDIT: 'WEB_ATTENDANCE_NETWORK_EDIT',
    WEB_ATTENDANCE_NETWORK_DELETE: 'WEB_ATTENDANCE_NETWORK_DELETE',
    WEB_ATTENDANCE_NETWORK_IMPORT: 'WEB_ATTENDANCE_NETWORK_IMPORT',
    WEB_ATTENDANCE_NETWORK_EXPORT: 'WEB_ATTENDANCE_NETWORK_EXPORT',
} as const;

